module.exports = __webpack_public_path__ + "static/media/rebuild.f1cd6f66.svg";